<template>
  <section class="email-verified-notice" v-if="vg_emailVerified">
    <p>Great news, Your email has been confirmed!</p>
    <span class="close-email-verified-notice" @click="va_setEmailVerified()"><i class="fas fa-times"></i></span>
  </section>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    computed: {
      ...mapGetters({
        vg_emailVerified: "emailverification/verified",
      })
    },
    methods: {
      ...mapActions({
        va_setEmailVerified: "emailverification/setVerified",
      })
    },
  }
</script>
